import {Box, Text} from "grommet";
import React, {useRef} from "react";
import {useReactToPrint} from "react-to-print";
import {formatCurrency} from "../../utils/numbers";
import StatusIcon from "../StatusIcon";
import BasePaymentForm from "./BasePaymentForm";
import {
    faCircleCheck as IconCircleCheck,
} from '@fortawesome/pro-light-svg-icons';
import Button from "../Button";

const PaymentConfirmation = (props) => {
    const confirmationRef = useRef();
    const { paymentConfirmationData, isBulkPay, printOptions, onReturnToMainMenu } = props;
    const { description, id, fee, amount, currency } = paymentConfirmationData;
    const handlePrint = useReactToPrint({
        content: () => confirmationRef.current,
    });
    return (
        <Box ref={confirmationRef}>
            <BasePaymentForm 
                primaryButton={(
                    <Box direction="column" gap="small" fill="horizontal">
                        <Button 
                            event={{section: 'payment_confirmation', element: 'print_confirmation'}}
                            label="Print receipt" 
                            secondary
                            hoverIndicator 
                            key="print" 
                            onClick={() => {
                                handlePrint(); 
                            }} />
                        {onReturnToMainMenu && (
                            <Button
                                event={{section: 'payment_confirmation', element: 'back_to_main_menu'}}
                                plain
                                hoverIndicator
                                label={(
                                    <Box fill="horizontal">
                                        <Text color="text-weak" textAlign="center">Back to main menu</Text>
                                    </Box>
                                )}
                                onClick={onReturnToMainMenu} />
                        )}
                    </Box>
                )} 
                isBulkPay={isBulkPay}
                printable 
                printOptions={printOptions}
                icon={IconCircleCheck}>
                <Box direction="column" margin={{top: 'medium', bottom: "small"}} justify="start" align="start" gap="small">
                    <StatusIcon status="ok" size="large" />
                    <Text size="large" weight={500}>
                        Thanks! You're all set.
                    </Text>
                    <Text>
                        Thanks for your payment of {formatCurrency(amount + (fee || 0), currency)}{description ? ` made with ${description}.` : '.'}
                    </Text>
                    { id && (
                        <Box align="start">
                            <Text>Your confirmation id is </Text>
                            <Text size="small" monospaced>{id}</Text>
                        </Box>
                    )}
                </Box>
            </BasePaymentForm>
        </Box>
    );
};

export default PaymentConfirmation;
